import React, { useState, useEffect } from 'react';
import { Modal, Typography } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { WhatsAppIcon } from '../icons/Whatsapp';
import { Messenger } from '../icons/Messenger';
import { Instagram } from '../icons/Instagram';

const { Text } = Typography;

const PremiumChatModal = ({ isOpen, onClose }) => {
  const [animateIcons, setAnimateIcons] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setAnimateIcons(false);

      const timer = setTimeout(() => {
        setAnimateIcons(true);
      }, 100);

      return () => clearTimeout(timer);
    } else {
      setAnimateIcons(false);
    }
  }, [isOpen]);

  const styles = `
    @keyframes iconSlide {
      from { 
        opacity: 0;
        transform: translateY(5px) scale(0.95);
      }
      to { 
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }
    
    .social-icon {
      opacity: 0;
    }
    
    .social-icon.animate {
      animation: iconSlide 0.3s ease-out forwards;
    }
    
    .social-icon:hover .social-box {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
    
    .delay-1 { animation-delay: 0.08s; }
    .delay-2 { animation-delay: 0.16s; }
    .delay-3 { animation-delay: 0.24s; }
    
    @media (max-width: 480px) {
      .social-box {
        padding: 14px 8px !important;
      }
      
      .icon-label {
        font-size: 12px !important;
      }
      
      .social-icon-img {
        width: 26px !important;
        height: 26px !important;
      }
    }
  `;

  const socialButtons = [
    {
      id: 1,
      icon: <WhatsAppIcon />,
      label: 'WhatsApp',
      color: '#25D366',
      url: 'https://wa.me/8801234567890',
      delay: 'delay-1'
    },
    {
      id: 2,
      icon: <Messenger />,
      label: 'Messenger',
      color: '#006AFF',
      url: 'https://m.me/yourpage',
      delay: 'delay-2'
    },
    {
      id: 3,
      icon: <Instagram />,
      label: 'Instagram',
      color: '#E4405F',
      url: 'https://ig.me/m/yourprofile',
      delay: 'delay-3'
    }
  ];

  return (
    <>
      <style>{styles}</style>

      <Modal
        open={isOpen}
        onCancel={onClose}
        footer={null}
        centered
        width={340}
        maskClosable={true}
        destroyOnClose={false}
        styles={{
          body: {
            padding: '20px 16px',
            textAlign: 'center'
          },
          content: {
            borderRadius: '16px',
          }
        }}
        // Removed custom animation props to use Ant Design's default
      >
        <div style={{
          marginBottom: '20px',
          textAlign: 'center'
        }}>
          <div style={{
            width: '60px',
            height: '60px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 12px',
          }}>
            <img
              src="/customer-service.png"
              alt="Customer Service"
              style={{
                width: '60px',
                height: '60px',
                objectFit: 'contain',
              }}
            />
          </div>

          <div style={{
            fontSize: '16px',
            fontWeight: 600,
            color: '#1f2937',
            lineHeight: '1.4',
            marginBottom: '4px'
          }}>
            আমাদের সাথে সরাসরি কথা বলুন
          </div>

          <Text style={{
            color: '#6b7280',
            fontSize: '13px',
            display: 'block'
          }}>
            পছন্দের মাধ্যম নির্বাচন করুন
          </Text>
        </div>

        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '10px',
          marginBottom: '20px',
          padding: '0 4px'
        }}>
          {socialButtons.map((button) => (
            <a
              key={button.id}
              href={button.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`social-icon ${animateIcons ? 'animate ' + button.delay : ''}`}
              style={{
                textDecoration: 'none',
                flex: '1',
                minWidth: '0'
              }}
            >
              <div className="social-box" style={{
                padding: '16px 8px',
                borderRadius: '10px',
                backgroundColor: 'white',
                border: `1px solid ${button.color}15`,
                textAlign: 'center',
                transition: 'all 0.2s ease',
                cursor: 'pointer',
                height: '100%',
                minWidth: '80px'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 10px',
                  height: '32px'
                }}>
                  {React.cloneElement(button.icon, {
                    style: {
                      width: '32px',
                      height: '32px',
                      color: button.color
                    },
                    className: 'social-icon-img'
                  })}
                </div>
                <Text className="icon-label" style={{
                  fontSize: '13px',
                  fontWeight: 500,
                  color: '#374151',
                  display: 'block',
                  lineHeight: '1.3',
                  whiteSpace: 'nowrap'
                }}>
                  {button.label}
                </Text>
              </div>
            </a>
          ))}
        </div>
      </Modal>
    </>
  );
};

export default PremiumChatModal;